import about from "../assets/img/Free medical camp 41-3R 22-may-2026/WhatsApp Image 2026-05-22 at 8.29.42 PM.jpeg"


export const About = () => {
    return <>
            {/* <!-- Page Header Start --> */}
        <div  className="container-fluid page-header py-5">
            <div  className="container text-center py-5">
                <h1  className="display-2 text-white mb-4 animated slideInDown">About</h1>
                <nav aria-label="breadcrumb">
                    <ol  className="breadcrumb justify-content-center mb-0 animated slideInDown">
                        <li  className="breadcrumb-item"><a href="#">Home</a></li>
                        <li  className="breadcrumb-item"><a href="#">Pages</a></li>
                        <li  className="breadcrumb-item text-white" aria-current="page">About</li>
                    </ol>
                </nav>
            </div>
        </div>
        {/* <!-- Page Header End -->


        <!-- About Start --> */}
        <div  className="container-fluid py-5">
            <div  className="container py-5">
                <div  className="row g-5">
                    <div  className="col-lg-6 col-md-12 wow fadeInUp" data-wow-delay=".3s">
                        <div  className="about-img">
                            <div  className="rotate-left "></div>
                            <div  className="rotate-right "></div>
                            <img src={about}  className="img-fluid" alt="img" style={{width: "100%", height: "620px", objectFit:"cover"}}/>
                            <div  className="bg-white experiences">
                                <h1  className="display-3">2</h1>
                                <h6  className="fw-bold">Years Of Experiences</h6>
                            </div>
                        </div>
                    </div>
                    <div  className="col-lg-6 col-md-12 wow fadeInUp" data-wow-delay=".6s">
                        <div  className="about-item overflow-hidden">
                            <h5  className="mb-2 px-3 py-1 text-dark rounded-pill d-inline-block border border-2 border-primary">About Care Foundation</h5>
                            <h1  className="display-5 mb-2">Serving Communities Through Care, Health & Education Since 2024</h1>
                            <p  className="fs-5" style={{"text-align": "justify"}}>Care Foundation is committed to improving lives through free medical camps, health awareness programs, educational support, and community welfare initiatives. We work to ensure that underserved individuals and families have access to essential healthcare, knowledge, and opportunities for a healthier and brighter future.</p>
                            <div  className="row">
                                <div  className="col-3">
                                    <div  className="text-center">
                                        <div  className="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i  className="fas fa-heartbeat fa-4x text-primary"></i>
                                        </div>
                                        <div  className="my-2">
                                            <h5>Health </h5>
                                            <h5>Awareness</h5>
                                        </div>
                                    </div>
                                </div>
                                <div  className="col-3">
                                    <div  className="text-center">
                                        <div  className="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i  className="fas fa-graduation-cap fa-4x text-primary"></i>
                                        </div>
                                        <div  className="my-2">
                                            <h5>Better</h5>
                                            <h5>Education</h5>
                                        </div>
                                    </div>
                                </div>
                                <div  className="col-3">
                                    <div  className="text-center">
                                        <div  className="p-4  rounded d-flex" style={{"align-items": "center", "justify-content": "center"}}>
                                            <i  className="fas fa-lightbulb fa-4x text-primary"></i>
                                        </div>
                                        <div  className="my-2">
                                            <h5>Bright </h5>
                                            <h5>Furture</h5>
                                        </div>
                                    </div>
                                </div>
                                <div  className="col-3">
                                    <div  className="text-center">
                                        <div  className="p-4  rounded d-flex" style={{"align-items" : "center", "justify-content" : "center"}}>
                                            <i  className="fas fa-hands-helping fa-4x text-primary"></i>
                                        </div>
                                        <div  className="my-2">
                                            <h5>Help </h5>
                                            <h5>Someone</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button type="button"  className="btn btn-primary border-0 rounded-pill px-4 py-3 text-white mt-5">Find Services</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- About End --> */}
    </>
}